/**
 * @generated SignedSource<<c1b8fc84154c3ef41c1ff767cc067adc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpDefaultLayout_viewer$data = {
  readonly homepage: {
    readonly modules: ReadonlyArray<{
      readonly type?: string | null;
      readonly visible?: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedEditorialModule_componentModule" | "HpSharedFeaturedBannerModule_componentModule" | "HpSharedTopHeroBannerModule_componentModule">;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpPersonalizedMixedGrid_viewer" | "HpSharedFeaturedModule_viewer" | "HpSharedTopHeroBannerModule_viewer">;
  readonly " $fragmentType": "HpDefaultLayout_viewer";
};
export type HpDefaultLayout_viewer$key = {
  readonly " $data"?: HpDefaultLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpDefaultLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "abTestList"
    },
    {
      "kind": "RootArgument",
      "name": "fetchInitialHomepage"
    },
    {
      "kind": "RootArgument",
      "name": "homepageId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isPersonalizedContentAboveFoldTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isRemoveTopHeroBannerTestVariant"
    },
    {
      "defaultValue": 8,
      "kind": "LocalArgument",
      "name": "mixedGridFirst"
    },
    {
      "defaultValue": "PERSONALIZED",
      "kind": "LocalArgument",
      "name": "recommendationType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpDefaultLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "abTestList",
          "variableName": "abTestList"
        },
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "homepageId"
        }
      ],
      "concreteType": "Homepage",
      "kind": "LinkedField",
      "name": "homepage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "condition": "isRemoveTopHeroBannerTestVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedTopHeroBannerModule_componentModule"
                    }
                  ],
                  "type": "TopHeroBannerModule",
                  "abstractKey": null
                }
              ]
            },
            {
              "condition": "fetchInitialHomepage",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "condition": "isPersonalizedContentAboveFoldTestVariant",
                      "kind": "Condition",
                      "passingValue": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "HpSharedEditorialModule_componentModule"
                        }
                      ]
                    }
                  ],
                  "type": "EditorialModule",
                  "abstractKey": null
                }
              ]
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*:: as any*/)
              ],
              "type": "LocationsModule",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "visible",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedFeaturedBannerModule_componentModule"
                }
              ],
              "type": "BottomBannerModule",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isRemoveTopHeroBannerTestVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedTopHeroBannerModule_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedFeaturedModule_viewer"
    },
    {
      "condition": "isPersonalizedContentAboveFoldTestVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isPersonalizedContentAboveFoldTestVariant",
              "variableName": "isPersonalizedContentAboveFoldTestVariant"
            },
            {
              "kind": "Variable",
              "name": "mixedGridFirst",
              "variableName": "mixedGridFirst"
            },
            {
              "kind": "Variable",
              "name": "recommendationType",
              "variableName": "recommendationType"
            }
          ],
          "kind": "FragmentSpread",
          "name": "HpPersonalizedMixedGrid_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "ff2002e5c8e15425db677c4d05cb821e";

export default node;
